<template>
	<div>
		<van-tabs v-model:active="active">
		  <van-tab title="建设要求">
				<div class="list">
					<div class="item" v-for="(item, index) in list1">
						<div class="left">
							<div class="title">{{ item.title }}</div>
							<div class="time">{{ item.update_time }}</div>
						</div>
						<div class="right">
							<van-button size="mini" type="primary" @click.stop="toLook(item.data_url[0])">查看</van-button>
						</div>
					</div>
					
				</div>
			</van-tab>
		  <van-tab title="建设档次">
				<div class="list">
					<div class="item" v-for="(item, index) in list2">
						<div class="left">
							<div class="title">{{ item.title }}</div>
							<div class="time">{{ item.update_time }}</div>
						</div>
						<div class="right">
							<van-button size="mini" type="primary" @click.stop="toLook(item.data_url[0])">查看</van-button>
						</div>
					</div>
					
				</div>
			</van-tab>
		  
		</van-tabs>
	</div>
</template>

<script>
import pdf from 'vue-pdf'
export default {
	components: {
		pdf
	},
	data() {
		return {
			active: 0,
			list1: [],
			list2: []
		}
	},
	mounted() {
		this.getData()
	},
	methods: {
		getData(){
			this.$api.unions
				.getDataList({type: 1	})
				.then((res) => {
					if (res.status * 1 === 200) {
						this.list1 = res.data
					}
				})
			this.$api.unions
					.getDataList({type: 2	})
					.then((res) => {
						if (res.status * 1 === 200) {
							this.list2 = res.data
						}
					})
		},
		toLook(urlData){
			let downEle = document.createElement('a')
			// let fname = fileName // 下载文件的名字
			let fname = `download` // 下载文件的名字
			downEle.href = urlData
			downEle.setAttribute('download', fname)
			document.body.appendChild(downEle)
			downEle.click()
			// this.downloadWeekly(urlData, '资料', 1233212)
		},
		// 下载
		downloadWeekly (url, pdfName, uuid) {
			// 调用子组件的下载方法
			this.downloadPDF(url, pdfName, uuid)
		},
 
		downloadPDF (url, fileName, uuid) {
			const _this = this
			fetch(url).then(function (response) {
				if (response.ok) {
					return response.arrayBuffer()
				}
				throw new Error('Network response was not ok.')
			}).then(function (arraybuffer) {
				let blob = new Blob([arraybuffer], {
					type: `application/pdf;charset-UTF-8` // word文档为msword,pdf文档为pdf
				})
 
				let objectURL = URL.createObjectURL(blob)
 
				let downEle = document.createElement('a')
				let fname = fileName // 下载文件的名字
				// let fname = `download` // 下载文件的名字
				downEle.href = objectURL
				downEle.setAttribute('download', fname)
				document.body.appendChild(downEle)
				downEle.click()
				DownloadArticleList({ // 此处是调用接口，将下载的文件信息传给后台
					uuid: uuid,
					openid: _this.openid
				}).then(res => {
					if (res.data.errno === 0) {
						alert('下载完成')
					}
					console.log('xiazai:', res.data)
				})
			}).catch(function (error) {
				console.log('There has been a problem with your fetch operation: ', error.message)
			})
		},
	}
}
</script>

<style lang="less" scoped>
.list{
	box-sizing: border-box;
	padding: .4rem 0;
	.item{
		display: flex;
		justify-content: space-between;
		align-items: center;
		border: 1px solid #eee;
		width: 97%;
		margin: auto;
		box-sizing: border-box;
		padding: .1rem;
		margin-bottom: .1rem;
		.left{
			.title{
				font-size: .3rem;
				font-weight: bolder;
			}
			.time{
				font-size: .2rem;
				color: #999;
				margin-top: .1rem;
			}
		}
		.right{
			display: flex;
		}
	}
}
</style>
